module.exports = __webpack_public_path__ + "media/images/top-search-bg-2@3x-8a2acf2bf61f76b27be6f0673bd2069a.png";